import logo_chosun from "../assets/media_logo/ic_media_chosun.svg"; // 조선일보
import logo_edaily from "../assets/media_logo/ic_media_edaily.svg"; // 이데일리
import logo_electronic from "../assets/media_logo/ic_media_electronic.svg"; // 전자신문
import logo_fnnews from "../assets/media_logo/ic_media_fnnews.svg"; // 파이낸셜뉴스
import logo_herald from "../assets/media_logo/ic_media_herald.svg"; // 헤럴드경제
import logo_hk from "../assets/media_logo/ic_media_hk.svg"; // 한국경제
import logo_mk from "../assets/media_logo/ic_media_mk.svg"; // 매일경제
import logo_seoul from "../assets/media_logo/ic_media_seoul.svg"; // 서울경제
import logo_fntimes from "../assets/media_logo/ic_media_fntimes.png"; // 한국금융신문
import logo_economist from "../assets/media_logo/ic_media_economist.png"; // 이코노미스트
import logo_dt from "../assets/media_logo/ic_media_dt.svg"; // 디지털타임스
import logo_newsis from "../assets/media_logo/ic_media_newsis.png"; // 뉴시스
import logo_fetv from "../assets/media_logo/ic_media_fetv.png"; // FETV
import logo_digital_today from "../assets/media_logo/ic_media_digital_today.png"; // 디지털투데이
import logo_byline from "../assets/media_logo/ic_media_byline_network.png"; // 바이라인네트워크
import logo_econovill from "../assets/media_logo/ic_media_econovill.png"; // 이코노믹리뷰


export const mediaList = [
	{
		category: `Company`,
		media: logo_mk,
		date: `2026.01.05`,
		title: `어니스트AI, 144억원 투자 유치…금융 AX 가속화 나선다`,
		link: `https://www.mk.co.kr/news/business/11923359`,
	},
	{
		category: `Tech`,
		media: logo_newsis,
		date: `2025.12.23`,
		title: `어니스트AI, 'AGI' 국책과제 1단계 달성…2단계 연구 추진`,
		link: `https://www.newsis.com/view/NISX20251223_0003452845`,
	},
	{
		category: `Interview`,
		media: logo_fetv,
		date: `2025.12.23`,
		title: `[온투업, 미래를 말하다] 서상훈 어니스트AI 대표 "AI 기술 통해 금융산업 문제 풀 것"`,
		link: `https://www.fetv.co.kr/news/article.html?no=208337`,
	},
	{
		category: `Company`,
		media: logo_fnnews,
		date: `2025.12.16`,
		title: `어니스트AI, 대출 99%가 '민간중금리'...AI기술로 1.5금융 역할`,
		link: `https://www.fnnews.com/news/202512161327080242`,
	},
	{
		category: `Company`,
		media: logo_electronic,
		date: `2025.12.10`,
		title: `[혁신플랫폼톡]창업 10년, 스타트업의 본질을 말하다`,
		link: `https://www.etnews.com/20251210000044`,
	},
	{
		category: `Company`,
		media: logo_digital_today,
		date: `2025.09.29`,
		title: `어니스트AI '어니스트펀드', 중저신용자 평균 금리 13%대 중반`,
		link: `https://www.digitaltoday.co.kr/news/articleView.html?idxno=594692`,
	},
	{
		category: `Interview`,
		media: logo_byline,
		date: `2025.09.09`,
		title: `[인터뷰] 온투업에서 'AI 금융기업'으로의 진화를 모색하는 어니스트AI`,
		link: `https://byline.network/2025/09/0915-2/`,
	},
	{
		category: `Tech`,
		media: logo_mk,
		date: `2025.08.26`,
		title: `어니스트AI, 차세대 AI 기술개발 국책과제 선정`,
		link: `https://www.mk.co.kr/news/economy/11402931`,
	},
	{
		category: `Award`,
		media: logo_mk,
		date: `2025.08.20`,
		title: `매경 핀테크 어워드 대상 AI 대출평가 어니스트AI`,
		link: `https://www.mk.co.kr/news/economy/11398640`,
	},
	{
		category: `Company`,
		media: logo_econovill,
		date: `2025.08.14`,
		title: `어니스트AI와 만난 KT의 영토 확장, 금융 특화 기술서 '나침반' 찾다`,
		link: `https://www.econovill.com/news/articleView.html?idxno=707434`,
	},
	{
		category: `Company`,
		media: logo_fntimes,
		date: `2025.08.03`,
		title: `서상훈號 어니스트AI, AI 기반 챌린저뱅크 컨소시엄 참여 추진 [온투업 10주년 현주소 (4)]`,
		link: `https://www.fntimes.com/html/view.php?ud=202508031024539737dd55077bc2_18`,
	},
	{
		category : `Company`,
		media: logo_mk,
		date: `2025.07.23`,
		title: `어니스트AI, 제주은행에 AI 솔루션 ‘렌딩인텔리전스’ 공급`,
		link : `https://stock.mk.co.kr/news/view/807010`,
	},
	{
		category : `Company`,
		media: logo_fntimes,
		date: `2025.07.23`,
		title: `저축은행, 온투업 연계투자 누적 취급실적 100억원 돌파…중금리 자금 활로 역할 톡톡`,
		link : `https://www.fntimes.com/html/view.php?ud=2025072215423766486a663fbf34_18`,
	},
	{
		category : `Interview`,
		media: logo_economist,
		date: `2025.06.22`,
		title: `창립 10주년 어니스트AI, 금융의 파운드리를 꿈꾼다`,
		link : `https://economist.co.kr/article/view/ecn202506190005`,
	},
	{
		category : `Company`,
		media: logo_fnnews,
		date: `2025.06.17`,
		title: `AI가 여는 대출시장…어니스트펀드, 출시 3주 만에 2만건 육박`,
		link : `https://n.news.naver.com/mnews/article/014/0005364136?sid=101`,
	},
	{
		category : `Interview`,
		media: logo_fntimes,
		date: `2025.06.16`,
		title: `서상훈 어니스트AI 대표 “대출 프로세스 전과정 효율화…금융 버티컬AI 구축 목표”`,
		link : `https://www.fntimes.com/html/view.php?ud=202506131512385619dd55077bc2_18`,
	},
	{
		category : `Tech`,
		media: logo_edaily,
		date: `2025.05.26`,
		title: `어니스트AI, ‘어니스트펀드’ 출시… 저축은행 연계 BaaS AI 대출 플랫폼 가동`,
		link : `https://n.news.naver.com/mnews/article/018/0006023771?sid=105`,
	},
	{
		category : `Tech`,
		media: logo_economist,
		date: `2024.11.01`,
		title: `어니스트AI, 삼성카드와 협력 통해 AI 기반 CSS 고도화 솔루션 성과 발표`,
		link : `https://n.news.naver.com/mnews/article/243/0000067298?sid=101`,
	},
	{
		category : `Award`,
		media: logo_dt,
		date: `2024.10.31`,
		title: `삼성금융, AI 혁신 사업 제시 최우수 스타트업 4곳`,
		link : `https://n.news.naver.com/mnews/article/029/0002912515?sid=101`,
	},
	{
		category : `Award`,
		media: logo_newsis,
		date: `2024.08.26`,
		title: `어니스트AI, 핀테크위크 금감원 쇼케이스 기업 선정`,
		link : `https://n.news.naver.com/mnews/article/003/0012748326?sid=101`,
	},
	{
		category : `Company`,
		media: logo_electronic,
		date: `2024.06.13`,
		title: `어니스트펀드, '어니스트AI'로 새출발…AI기술금융 선도 포부`,
		link : `https://n.news.naver.com/mnews/article/030/0003214034?sid=101`,
	},
	{
		category: `Company`,
		media: logo_hk,
		date: `2024.01.11`,
		title: `어니스트펀드, 진원그룹서 50억원 투자 유치…'AI 솔루션' 기술 인정`,
		link: `https://n.news.naver.com/mnews/article/015/0004935611?sid=101`,
	},
	{
		category: `Company`,
		media: logo_electronic,
		date: `2023.09.19`,
		title: `어니스트펀드, AI 여신 종합 솔루션 '렌딩 인텔리전스' B2B 상용화`,
		link: `https://n.news.naver.com/mnews/article/030/0003137727?sid=101`,
	},
	{
		category: `Company`,
		media: logo_fnnews,
		date: `2023.03.30`,
		title: `"온투업 기관투자 활성화 대비"...어니스트펀드-BNK저축은행 맞손`,
		link: `https://n.news.naver.com/mnews/article/014/0004989234?sid=101`,
	},
	{
		category: `Tech`,
		media: logo_herald,
		date: `2024.03.28`,
		title: `어니스트펀드, SK그룹사에 ‘세입자 신용평가 모델’ 공급한다`,
		link: `https://n.news.naver.com/mnews/article/016/0002287312?sid=101`,
	},
	{
		category: `Tech`,
		media: logo_edaily,
		date: `2023.02.01`,
		title: `어니스트펀드, AI기반 ‘데이터 연합학습 솔루션’ 상용화`,
		link: `https://n.news.naver.com/mnews/article/018/0005415974?sid=101`,
	},
	{
		category: `Tech`,
		media: logo_seoul,
		date: `2022.08.18`,
		title: `어니스트펀드, 인공지능 및 빅데이터 기반 신용평가 등 특허 출원`,
		link: `https://www.sedaily.com/NewsView/269RP4UVC2`,
	},
	{
		category: `Interview`,
		media: logo_seoul,
		date: `2024.02.02`,
		title: `"리스크 20% 줄인 어니스트펀드 신용평가…온투업 B2B 스텝업 기회로"`,
		link: `https://n.news.naver.com/mnews/article/011/0004295300?sid=101`,
	},
	{
		category: `Interview`,
		media: logo_chosun,
		date: `2023.12.04`,
		title: `어니스트펀드 신윤제 CDO(최고데이터책임자) "AI가 300개 항목으로 돈 잘 갚을 고객 찾죠"`,
		link: `https://economychosun.com/site/data/html_dir/2023/12/04/2023120400027.html`,
	},
	{
		category: `Interview`,
		media: logo_fnnews,
		date: `2023.12.04`,
		title: `회·파·복 두려운 금융사에 AI솔루션 공급`,
		link: `https://n.news.naver.com/mnews/article/014/0005110035?sid=101`,
	},
	{
		category: `Award`,
		media: logo_electronic,
		date: `2024.01.11`,
		title: `어니스트펀드, 2023 'D-테스트베드' 사업 금융위원장 대상 수상`,
		link: `https://n.news.naver.com/mnews/article/030/0003172700?sid=101`,
	},
	{
		category: `Award`,
		media: logo_mk,
		date: `2017.08.29`,
		title: `어니스트펀드, 매경 핀테크 어워드 우수상 수상`,
		link: `https://www.mk.co.kr/news/special-edition/7954723`,
	},
	{
		category: `Award`,
		media: logo_hk,
		date: `2016.09.28`,
		title: `어니스트펀드, 한경 핀테크대상 데이터분석·리스크 관리로 최우수상`,
		link: `https://www.hankyung.com/news/app/newsview.php?aid=2016092826631&intype=1`,
	},
];
